import { UserPlus, Users } from "lucide-react";
import { REPORTS } from "@/constants/testIds";

/** Tarjeta de clientes nuevos vs recurrentes en el periodo elegido. */
export default function ClientsCard({ newCount, returningCount }) {
  const total = newCount + returningCount;
  const newPct = total ? Math.round((newCount / total) * 100) : 0;
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={REPORTS.clientsCard}>
      <h3 className="text-sm font-medium text-foreground mb-4">Clientes en el periodo</h3>
      <div className="grid grid-cols-2 gap-3">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-brand-light flex items-center justify-center shrink-0">
            <UserPlus className="w-4 h-4 text-brand" />
          </div>
          <div>
            <p className="font-serif text-2xl text-foreground" data-testid={REPORTS.clientsNewCount}>{newCount}</p>
            <p className="text-xs text-muted-foreground">Nuevos</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-[#E3EDE1] flex items-center justify-center shrink-0">
            <Users className="w-4 h-4 text-[#5B7A54]" />
          </div>
          <div>
            <p className="font-serif text-2xl text-foreground" data-testid={REPORTS.clientsReturningCount}>{returningCount}</p>
            <p className="text-xs text-muted-foreground">Recurrentes</p>
          </div>
        </div>
      </div>
      {total > 0 && (
        <div className="mt-4">
          <div className="h-2 w-full rounded-full bg-[#E3EDE1] overflow-hidden">
            <div className="h-full bg-brand" style={{ width: `${newPct}%` }} />
          </div>
          <p className="text-xs text-muted-foreground mt-1.5">{newPct}% de los clientes atendidos fueron nuevos</p>
        </div>
      )}
    </div>
  );
}
